import * as React from 'react';
import { __ } from 'react-i18n';
import styled from 'styled-components';
import { rem } from 'polished';
import { InfoText, InfoType } from '../../General/InfoText';
import { FlexCol, FlexRowCenter } from '../../../Defaults/Flexbox/Flexbox';
import {
  Button,
  ButtonLink,
  ButtonPrimaryLink,
  ButtonFourthLink,
} from '../../General/Button';
import { ImitradeSummaryValue as SummaryValue } from './ImitradeSummaryValue';
import { ImitradeFinalValue as FinalValue } from './ImitradeFinalValue';
import { getCartSummaryInfo } from '../../../../utilities/selectors';
import { getSanitasCartSummaryInfo } from '../../selectors';
import { formatPriceToString } from '../../../../utilities';
import { Loader } from './ThirdStep';
import { FreeDeliveryBox } from './FreeDeliveryBox';

interface Props {
  handleStepChange?: (step: number) => void;
  withoutBottomPart?: boolean;
  data: any;
  isFetching: boolean;
  freeDel: number | null;
}

function SecondStep({
  handleStepChange,
  data,
  withoutBottomPart = false,
  isFetching,
  freeDel,
}: Props) {
  const {
    totalPrice,
    totalPriceWithoutVat,
    vatTotal,
    currency,
    totalItemsPrice,
  } = getCartSummaryInfo(data);
  const {
    vatGroup20Total,
    vatGroup20TotalDph,
    vatGroup20TotalWithDph,
  } = getSanitasCartSummaryInfo(data);
  const { items } = data;
  const hasNullPriceItems = items.some(i => i.sum_price === 0);

  return (
    <>
      <DesktopFields>
        <SummaryValue
          title={__('Cena tovaru bez DPH')}
          value={`${totalPriceWithoutVat} ${currency}`}
        />
        <SummaryValue
          title={__('DPH 20 %')}
          value={`${vatTotal} ${currency}`}
        />
        <SummaryValue
          title={__('Cena tovaru s DPH')}
          value={`${totalPrice} ${currency}`}
        />
        <FreeDeliveryBox value={freeDel} currency={currency} />
        <FinalValue
          title={__('Celkom k úhrade s DPH')}
          value={`${totalPrice} ${currency}`}
        />
      </DesktopFields>
      <MobileFields>
        <SummaryValue
          title={__('Cena bez DPH')}
          value={`${totalPriceWithoutVat} ${currency}`}
        />
        <SummaryValue
          title={__('DPH 20 %')}
          value={`${vatTotal} ${currency}`}
        />
        <SummaryValue
          title={__('Cena s DPH')}
          value={`${totalPrice} ${currency}`}
        />
        <FreeDeliveryBox value={freeDel} currency={currency} />
        <FinalValue
          title={__('Celkom k úhrade s DPH')}
          value={`${totalPrice} ${currency}`}
        />
      </MobileFields>
      {!withoutBottomPart && (
        <>
          {hasNullPriceItems && (
            <InfoText
              type={InfoType.INFO}
              noIcon={true}
              info={__(
                'Pozor! V košíku sa vyskytujú produkty, ktoré nemajú uvedenú cenu. Ich cena vám bude započítaná do faktúry.',
              )}
              marginBottom={24}
            />
          )}
          <NextButton
            disabled={isFetching}
            // tslint:disable-next-line:jsx-no-lambda
            onClick={() => (handleStepChange ? handleStepChange(3) : {})}
          >
            {isFetching ? (
              <FlexRowCenter>
                <Loader className="marginLeft" small={true} />
              </FlexRowCenter>
            ) : (
              __('Pokračovať v objednávke')
            )}
          </NextButton>
          <BackButton
            // tslint:disable-next-line:jsx-no-lambda
            onClick={() => (handleStepChange ? handleStepChange(1) : {})}
          >
            {__('Späť')}
          </BackButton>
        </>
      )}
    </>
  );
}

const NextButton = styled(ButtonPrimaryLink)`
  width: 100%;
  max-width: ${rem(328)};
  margin-top: ${rem(32)};

  ${({ theme }) => theme.mediab.s450`
    margin-top: 0;
  `}
`;

const BackButton = styled(ButtonFourthLink)`
  max-width: ${rem(328)};
  margin-top: ${rem(16)};
`;

const DesktopFields = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(328)};

  ${({ theme }) => theme.mediab.l925`
    display: none;
  `}
`;

const MobileFields = styled(FlexCol)`
  display: none;
  margin-bottom: ${rem(16)};
  width: 100%;

  ${({ theme }) => theme.mediab.l925`
    display: flex;
  `}
`;

export { SecondStep };
